import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import CMSPage from "./pages/CMSPage";
import NotFoundPage from "./pages/NotFoundPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import BlogTagPage from "./pages/BlogTagPage";
import BlogAuthorPage from "./pages/BlogAuthorPage";
import BlogCategoryPage from "./pages/BlogCategoryPage";

/**
 * Main application component with routing
 */
function App() {
  return (
    <Routes>
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/" element={<Layout />}>
        {/* Static routes for known pages */}
        <Route index element={<HomePage />} />

        {/* Blog routes - before :slug catch-all */}
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/tags/:slug" element={<BlogTagPage />} />
        <Route path="blog/categories/:slug" element={<BlogCategoryPage />} />
        <Route path="blog/authors/:slug" element={<BlogAuthorPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />

        <Route path=":slug" element={<CMSPage />} />

        {/* 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
